import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './pages/routes';

function App() {
    return (
        <BrowserRouter
            future={{ v7_startTransition: false, v7_relativeSplatPath: false }}
        >
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;
